<template>
  <div>
    <v-subheader>
      <span
        v-show="!menuIsVerticalNavMini || (menuIsVerticalNavMini && isMouseHovered)"
        class="title-wrapper"
        :class="{ 'no-style': menuIsVerticalNavMini && !isMouseHovered }"
      >
        <span>{{ item.subheader }}</span>
      </span>

      <v-icon v-show="menuIsVerticalNavMini && !isMouseHovered">
        {{ icons.mdiMinus }}
      </v-icon>
    </v-subheader>
    <component :is="item.component"></component>
  </div>
</template>

<script>
import useAppConfig from '@core/@app-config/useAppConfig'
import { mdiMinus, mdiDatabaseSearchOutline } from '@mdi/js'
import { ref, inject } from '@vue/composition-api'
import ProjectsNav from '@/components/project-management/project/ProjectsNav.vue'

export default {
  components: { ProjectsNav },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { menuIsVerticalNavMini } = useAppConfig()
    const isMouseHovered = inject('isMouseHovered')
    const entries = ['project-102', 'project-103']
    const model = ref(null)

    return {
      menuIsVerticalNavMini,
      isMouseHovered,
      entries,
      model,
      icons: {
        mdiMinus,
        mdiDatabaseSearchOutline,
      },
    }
  },
}
</script>

<style scoped lang="scss">
@import '~vuetify/src/styles/styles.sass';

@include theme(v-subheader) using ($material) {
  white-space: nowrap;
  position: relative;

  .v-icon {
    color: map-deep-get($material, 'dividers');
  }

  .title-wrapper {
    &:not(.no-style) {
      width: 100%;
      // text-align: center;
      position: absolute;
      left: 0;
      border-bottom: 1px solid map-deep-get($material, 'dividers');
      line-height: 0.1em;
      // margin: 10px 0 20px;
    }
  }

  .title-wrapper span {
    background: #072146;
    padding: 0 10px;
    font-size: 0.75rem;

    @include ltr() {
      margin-left: 16px;
    }
    @include rtl() {
      margin-right: 16px;
    }
  }
}
</style>
